// gatsby-browser.js
import React from "react"
import RootWrapper from "./src/components/RootWrapper"

export const wrapPageElement = ({ element }) => {
  return <RootWrapper element={element} />
}
